import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CompareSessionWithLinkedAccount } from '../session/session.actions';
import { LinkAccount } from './link-account.actions';
import { LinkAccountStateModel } from './model/link-account-state-model';

const DEFAULT_STATE: LinkAccountStateModel = {
  accountId: null,
  email: null,
  vendor: null
};

@State<LinkAccountStateModel>({
  name: 'linkAccount',
  defaults: DEFAULT_STATE
})
@Injectable()
export class LinkAccountState {
  @Selector()
  static accountId(state: LinkAccountStateModel): string | null {
    return state.accountId;
  }

  @Selector()
  static email(state: LinkAccountStateModel): string | null {
    return state.email;
  }

  @Selector()
  static accountIdLinked(state: LinkAccountStateModel): boolean {
    return state.accountId !== null;
  }

  @Selector()
  static vendor(state: LinkAccountStateModel): string | null {
    return state.vendor;
  }

  @Action(LinkAccount)
  linkAccount(ctx: StateContext<LinkAccountStateModel>, { linkedAccount, vendor }: LinkAccount): Observable<unknown> {
    ctx.patchState({ accountId: linkedAccount?.accountId ?? null, email: linkedAccount?.email ?? null, vendor });
    return ctx.dispatch(new CompareSessionWithLinkedAccount());
  }
}
